/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { ScopeQuestionGroupOptionalValue } from '../../../types/survey';
import { ScopeQuestionOptionalValue } from '../../../types/surveyScope';
import { safeColours } from '../../form/partials/ColourPickerPopup';
import { Row, Column, TrackingList } from '../../tracking-list';
import { BulkActionToolbarSelectedUtrv } from './BulkActionToolbar';
import { GroupSelectbox } from './GroupSelectBox';
import { QUESTION } from '../../../constants/terminology';

interface GroupTitleProps {
  isOpen: boolean;
  toggle?: () => void;
  questionList: ScopeQuestionOptionalValue[];
  questionGroup: ScopeQuestionGroupOptionalValue;
  rowRef?: React.ForwardedRef<HTMLDivElement>;
  enableBulkActions: boolean;
  selectedQuestionIds: string[];
  toggleSelectQuestions: (utrvs: BulkActionToolbarSelectedUtrv[]) => void;
}

export const GroupTitle = (props: GroupTitleProps) => {
  const { toggle, isOpen, questionList, questionGroup, rowRef, enableBulkActions, selectedQuestionIds } =
    props;

  const hasQuestions = questionList && questionList.length > 0;
  const icon = !hasQuestions ? '' : isOpen ? 'fa-chevron-down' : 'fa-chevron-right';
  const colour = questionGroup.groupData && questionGroup.groupData.colour;

  const isSafeColour = !colour || safeColours.includes(colour);
  const onClick = hasQuestions ? () => toggle?.() : undefined;

  const style = colour ? { backgroundColor: colour, borderColor: colour } : undefined;
  const isScopeView = Boolean(questionGroup.count);

  if (isScopeView) {
    return (
      <Row className='scopeGroupTitle'>
        <Column className='h4 scopeGroupName'>{questionGroup.groupName}</Column>
        <Column >{`${questionGroup.count} ${QUESTION.SINGULAR}${questionGroup.count === 1 ? '' : 's'}`}</Column>
      </Row>
    );
  }

  const toggleSelectQuestions = (utrvs: BulkActionToolbarSelectedUtrv[]) => {
    props.toggleSelectQuestions(utrvs);
    // if (!isOpen) {
    //   toggle?.();
    // }
  }

  return (
    <TrackingList className={'questionListGroup mb-1'}>
      <Row ref={rowRef} onClick={toggle ? onClick : null} style={style} className={!isSafeColour ? 'text-ThemeTextWhite' : ''}>
        {toggle
          ? <Column><i className={`ml-2 fa ${icon}`} /></Column>
          : <Column className='px-1' />
        }
        <Column stretch truncate>
          {questionGroup.groupName}
        </Column>
        <Column className='statsCol'>{questionGroup.count ?? questionList.length}</Column>
        {enableBulkActions ? (
          <GroupSelectbox
            questionGroup={questionGroup}
            questionList={questionList}
            selectedQuestionIds={selectedQuestionIds}
            toggleSelectQuestions={toggleSelectQuestions}
          />
        ) : null}
      </Row>
    </TrackingList>
  );
}
